export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000';

export const dbService = {
  async saveUserMissionHistory(userId: string, runRecord: any) {
    const response = await fetch(`${API_BASE_URL}/api/users/${userId}/mission-history`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(runRecord)
    });
    if (!response.ok) throw new Error('Failed to save mission history');
    return await response.json();
  },
  async getUser(id: string) {
    const response = await fetch(`${API_BASE_URL}/api/users/${id}`, {
      credentials: 'include'
    });
    if (!response.ok) throw new Error('Failed to fetch user');
    return await response.json();
  },
  async getUsers() {
    const response = await fetch(`${API_BASE_URL}/api/users`, {
      credentials: 'include'
    });
    if (!response.ok) throw new Error('Failed to fetch users');
    return await response.json();
  },
  async getMissions() {
    const response = await fetch(`${API_BASE_URL}/api/missions`, {
      credentials: 'include'
    });
    if (!response.ok) throw new Error('Failed to fetch missions');
    return await response.json();
  },
  async getMission(id: string) {
    const response = await fetch(`${API_BASE_URL}/api/missions/${id}`, {
      credentials: 'include'
    });
    if (!response.ok) throw new Error('Failed to fetch mission');
    return await response.json();
  },
  async addMission(payload: any) {
    const response = await fetch(`${API_BASE_URL}/api/missions`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(payload)
    });
    if (!response.ok) throw new Error('Failed to create mission');
    return await response.json();
  },
  async updateMission(payload: any) {
    const response = await fetch(`${API_BASE_URL}/api/missions/${payload.id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(payload)
    });
    if (!response.ok) throw new Error('Failed to update mission');
    return await response.json();
  },
  async deleteMission(id: string) {
    const response = await fetch(`${API_BASE_URL}/api/missions/${id}`, { 
      method: 'DELETE',
      credentials: 'include'
    });
    if (!response.ok) throw new Error('Failed to delete mission');
    return await response.json();
  },
  async updateUser(id: string, payload: any) {
    const response = await fetch(`${API_BASE_URL}/api/users/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(payload)
    });
    if (!response.ok) throw new Error('Failed to update user');
    return await response.json();
  },
  async addUser(payload: any) {
    const response = await fetch(`${API_BASE_URL}/api/users`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(payload)
    });
    if (!response.ok) throw new Error('Failed to create user');
    return await response.json();
  },
  async deleteUser(id: string) {
    const response = await fetch(`${API_BASE_URL}/api/users/${id}`, { 
      method: 'DELETE',
      credentials: 'include'
    });
    if (!response.ok) throw new Error('Failed to delete user');
    return await response.json();
  },
};

export interface User {
  id: string
  name: string
  email?: string
  password?: string
  /** user type: parent, child, or family (optional; isAdmin is a separate boolean flag) */
  type?: 'parent' | 'child' | 'family'
  /** optional profile image stored as a data URL */
  profileImageDataUrl?: string | null
  /** optional avatar image URL from cloud */
  avatar_url?: string | null
  /** optional stored passkey credential id (base64) */
  passkeyId?: string
  /** whether this user uses a passkey for authentication */
  usePasskey?: boolean
  /** whether this user is an account holder (for new accounts) */
  isAccount?: boolean
  /** whether this user is an admin */
  isAdmin?: boolean
  /** id of the account holder of this user's family (if any) */
  account_id?: string
  createdAt: Date
}



export interface MissionStep {
  id: string;
  name: string;
}

export interface Mission {
  id: string;
  name: string;
  totalTime: number; // in seconds
  steps: MissionStep[];
  createdAt: Date;
  user_id?: string; // assigned child user ID
  account_id?: string; // link mission to family account holder
  history?: Array<{
    runDate: string | number;
    elapsedTime: number;
    steps: Array<{ name: string; elapsedTime: number }>;
  }>;
}
// ...existing code...

// Earworm event and status types
export interface EarwormEvent {
  text: string
  time: string | number
}

export interface EarwormStatus {
  lastevent: EarwormEvent
  events: EarwormEvent[]
}

// Main Earworm type
export interface Earworm {
  id: string
  user_id: string
  name: string
  source?: string | null
  image_url?: string | null
  analysis?: any
  lyrics?: string | null
  suno_task_id?: string | null
  suno_task_status?: string | null
  suno_audio_url?: string | null
  suno_audio_url2?: string | null
  suno_audio_id?: string | null
  suno_audio_id2?: string | null
  suno_ts_lyrics?: any
  suno_ts_lyrics2?: any
  status?: string | EarwormStatus | null
  created_at?: Date | null
  modified_at?: Date | null
}
